import React from 'react'

const Home = () => {
  return (
    <>
      <section className='home' id='home'>
        <div className='content'>
            <h3>Delicious<span>&nbsp;food & Indian&nbsp;</span>Traditions</h3>
            <p>orci ac auctor augue mauris</p>
            <a href='#' className='btn'>Get Yours Now</a>
        </div>
      </section>
    </>
  )
}

export default Home
